const currencies = [
  {
    currency: 'TRY',
  },
  {
    currency: 'USD',
  },
  {
    currency: 'RUB',
  },
  {
    currency: 'EUR',
  },
];

export default currencies;
